import { useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const VendorDisclaimer = () => {
  const [body, setBody] = useState("");
  const [version, setVersion] = useState("");
  const [effective, setEffective] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/vendor-disclaimer/text`)
      .then((r) => r.ok ? r.json() : Promise.reject(r.status))
      .then((d) => {
        setBody(d.body || "");
        setVersion(d.version || "");
        setEffective(d.effective_date || "");
      })
      .catch(() => setErr("Could not load disclaimer. Refresh or email hello@moovinforward.org."));
  }, []);

  return (
    <div data-testid="vendor-disclaimer-page" style={{
      minHeight: "100vh", background: "#f5efe1", color: "#1b2a4e",
      fontFamily: "Georgia, 'Times New Roman', serif",
      padding: "2rem 1rem",
    }}>
      <div style={{ maxWidth: 880, margin: "0 auto" }}>
        <div style={{ borderTop: "4px solid #1b2a4e", paddingTop: "1.4rem" }}>
          <div style={{ fontSize: "0.72rem", letterSpacing: "0.22em", textTransform: "uppercase", color: "#b8915a", fontWeight: 800 }}>
            Moovin Forward LLC
          </div>
          <h1 data-testid="disclaimer-title" style={{ fontSize: "2rem", margin: "0.4rem 0 0.2rem", fontWeight: 700 }}>
            Vendor Network Disclaimer
          </h1>
          <div style={{ fontSize: "0.85rem", color: "#7a8f7e" }}>
            {version && <>Version <strong>{version}</strong></>}
            {effective && <> · Effective {effective}</>}
          </div>
        </div>

        <div style={{ marginTop: "1.6rem", display: "flex", gap: "0.7rem", flexWrap: "wrap" }}>
          <a
            data-testid="download-disclaimer-pdf"
            href={`${BACKEND_URL}/api/vendor-disclaimer/download`}
            target="_blank"
            rel="noreferrer"
            style={{
              background: "#1b2a4e", color: "#f5efe1",
              padding: "0.6rem 1.1rem", borderRadius: 4, textDecoration: "none",
              fontSize: "0.88rem", fontWeight: 700, letterSpacing: "0.04em",
            }}
          >
            📄 Download PDF
          </a>
          <button
            data-testid="copy-disclaimer-link"
            type="button"
            onClick={() => {
              try {
                navigator.clipboard.writeText(window.location.href);
                window.alert("Link copied. Paste to vendor anywhere.");
              } catch { /* no clipboard */ }
            }}
            style={{
              background: "transparent", color: "#1b2a4e",
              border: "1px solid #1b2a4e", padding: "0.6rem 1.1rem", borderRadius: 4,
              fontSize: "0.88rem", fontWeight: 700, letterSpacing: "0.04em", cursor: "pointer",
            }}
          >
            🔗 Copy Link
          </button>
        </div>

        {err && (
          <div data-testid="disclaimer-error" style={{ marginTop: "1.4rem", background: "#fee2e2", color: "#7f1d1d", padding: "0.9rem", borderRadius: 4 }}>
            {err}
          </div>
        )}

        <pre
          data-testid="disclaimer-body"
          style={{
            marginTop: "1.6rem",
            whiteSpace: "pre-wrap", wordBreak: "break-word",
            fontFamily: "Georgia, serif", fontSize: "0.92rem", lineHeight: 1.6,
            background: "#ffffff", padding: "1.6rem", borderRadius: 4,
            border: "1px solid rgba(27,42,78,0.15)",
            boxShadow: "0 2px 10px rgba(27,42,78,0.04)",
          }}
        >
          {body || (err ? "" : "Loading…")}
        </pre>

        <div style={{ marginTop: "2rem", textAlign: "center", fontSize: "0.78rem", color: "#7a8f7e" }}>
          Moovin Forward LLC · Texas LLC · hello@moovinforward.org · (817) 381-8831 · moovinforward.org
          <br />
          <strong>NO BROKERAGE. NO PROPERTY MANAGEMENT. NO LEASING.</strong>
        </div>
      </div>
    </div>
  );
};

export default VendorDisclaimer;
